export enum AIPromptEventName {
  TestAIPromptEvent = 'testAIPromptEvent',
  TestAIPromptEvent2 = 'testAIPromptEvent2',
  ChatbotUserPrompt = 'chatbotUserPrompt',
  CantileverAIUserPrompt = 'cantileverAIUserPrompt',
}

export enum AIResponseEventName {
  TestAIResponseEvent = 'testAIResponseEvent',
  TestAIResponseEvent2 = 'testAIResponseEvent2',
  ChatbotTextResponse = 'chatbotTextResponse',
  CantileverAITextResponse = 'cantileverAITextResponse',
  DelphiResponse = 'delphiResponse',
  RooftopReportExecutiveSummaryResponse = 'rooftopReportExecutiveSummaryResponse',
  RooftopReportSectionFindingsResponse = 'rooftopReportSectionFindingsResponse',
  RooftopReportCapitalRecommendationsResponse = 'rooftopReportCapitalRecommendationsResponse',
}

export type EventName = AIPromptEventName | AIResponseEventName
